import { Link } from "react-router-dom";
import { allCategories, hotMovies, latestMovies } from "@/lib/catalog";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-primary-800/60 bg-primary-950">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="flex cursor-pointer items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center border border-accent-500/70 font-heading text-lg font-bold text-accent-500">
                情
              </span>
              <span className="leading-tight">
                <span className="block font-heading text-base font-bold text-foreground-50">日本情色电影</span>
                <span className="block text-[9px] tracking-widest2 text-foreground-500 font-label">
                  JAPAN EROTIC CINEMA ARCHIVE
                </span>
              </span>
            </Link>
            <p className="mt-5 max-w-md text-[13px] leading-relaxed text-foreground-400">
              一个以编辑视角整理日本成人文艺电影的影像资料站。我们记录片目、导演脉络、摄影语言与行业动态，
              用文字而非影像呈现作品的气质。所有条目均为演示示例。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-[12px] font-label">
              <a
                href="mailto:hello@japan-erotic-cinema.demo"
                className="flex cursor-pointer items-center gap-2 text-foreground-300 transition-colors hover:text-accent-400"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-full border border-background-300/70">
                  <i className="ri-mail-line text-xs" />
                </span>
                hello@japan-erotic-cinema.demo
              </a>
              <span className="flex items-center gap-2 text-foreground-500">
                <span className="flex h-4 items-center rounded-full border border-primary-500/70 px-2 text-[10px] text-primary-300">
                  18+
                </span>
                仅限成年观众
              </span>
            </div>
          </div>

          <div>
            <h4 className="flex items-center gap-2 font-heading text-[13px] font-semibold text-foreground-100">
              <a href="#footer-category" className="cursor-pointer hover:text-accent-400">
                影像分类
              </a>
            </h4>
            <ul id="footer-category" className="mt-4 flex flex-col gap-2.5 text-[12px] font-label">
              {allCategories.map((category) => (
                <li key={category.slug}>
                  <Link
                    to={`/category/${category.slug}`}
                    className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400"
                  >
                    {category.name} · {category.en}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="flex items-center gap-2 font-heading text-[13px] font-semibold text-foreground-100">
              <a href="#footer-browse" className="cursor-pointer hover:text-accent-400">
                浏览入口
              </a>
            </h4>
            <ul id="footer-browse" className="mt-4 flex flex-col gap-2.5 text-[12px] font-label">
              <li>
                <Link to="/" className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400">
                  首页焦点
                </Link>
              </li>
              <li>
                <Link
                  to={`/detail/${latestMovies(1)[0].id}`}
                  className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400"
                >
                  最新上架 · {latestMovies(1)[0].title}
                </Link>
              </li>
              <li>
                <Link
                  to={`/detail/${hotMovies(1)[0].id}`}
                  className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400"
                >
                  热度榜首 · {hotMovies(1)[0].title}
                </Link>
              </li>
              <li>
                <Link to="/news" className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400">
                  行业资讯与影评
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400">
                  全站搜索
                </Link>
              </li>
              <li>
                <a
                  href="mailto:hello@japan-erotic-cinema.demo"
                  className="cursor-pointer text-foreground-400 transition-colors hover:text-accent-400"
                >
                  联系编辑部
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-4 border-t border-primary-800/50 pt-6 text-[11px] text-foreground-500 sm:flex-row sm:items-center sm:justify-between font-label">
          <p>© {year} 日本情色电影 · 影像档案。本站为演示项目，所有影片、人物、评分与资讯均为虚构示例。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>不提供播放与下载</span>
            <span className="hidden h-3 w-px bg-foreground-700 sm:block" />
            <span>内容仅作影视资料整理</span>
          </p>
        </div>
      </div>
    </footer>
  );
}